var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIspPremium = function SvgIspPremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1548 6.89541C14.2067 6.30972 13.1142 5.99967 11.9997 6C10.8853 5.99967 9.79278 6.30972 8.84466 6.89541C7.89653 7.4811 7.13026 8.31928 6.63173 9.316L8.42073 10.211C8.75279 9.54616 9.26348 8.98697 9.89556 8.59613C10.5276 8.2053 11.2561 7.99827 11.9992 7.99827C12.7424 7.99827 13.4708 8.2053 14.1029 8.59613C14.735 8.98697 15.2457 9.54616 15.5777 10.211L17.3677 9.316C16.8692 8.31928 16.1029 7.4811 15.1548 6.89541Z",
    fill: "#48CCCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2579 3.49267C15.6778 2.51647 13.8571 1.9996 11.9997 2C10.1422 1.99941 8.3213 2.51619 6.74102 3.49241C5.16074 4.46862 3.88359 5.86569 3.05273 7.527L4.84273 8.422C5.50732 7.09297 6.52892 5.97529 7.79303 5.19425C9.05714 4.41321 10.5138 3.99968 11.9997 4C13.4857 3.99968 14.9423 4.41321 16.2064 5.19425C17.4705 5.97529 18.4922 7.09297 19.1567 8.422L20.9457 7.527C20.115 5.86584 18.838 4.46888 17.2579 3.49267Z",
    fill: "#48CCCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.4L5 13.2V22H19V13.2L15.5 15.4L12 11L8.5 15.4Z",
    fill: "#48CCCD"
  })));
};
export default SvgIspPremium;